import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../app.constants';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { SearchActiveResultModel } from '../../shared/models/search-related/SearchActiveResultModel';
import { HubConnection } from '@aspnet/signalr';
import * as SignalR from '@aspnet/signalr';
import { TrafficModel } from '../../shared/models/traffic-related/TrafficModel';
import { BehaviorSubject } from 'rxjs';
import { NotificationHandlerService } from '../../index';

@Injectable()
export class TrafficLiveService {

    private actionUrl: string;
    private headers: Headers;
    private _hubConnection: HubConnection | undefined;
    public newTrafficEvent = new BehaviorSubject<TrafficModel>(null);
    public isConnected = new BehaviorSubject<boolean>(false);

    constructor(private _http: Http, private _configuration: Configuration, private oidcSecurityService: OidcSecurityService, private _notificationService: NotificationHandlerService) {
        this.actionUrl = `https://traffic.radionetportal.com/hub/trafficstreamadmin`;
        //this.actionUrl = `https://localhost:44358/hub/trafficstreamadmin`;
    }

    public Connect(identifier: string): void {
        const token = this.oidcSecurityService.getToken();
        let queryStr = '?identifier=' + identifier;
        this._hubConnection = new SignalR.HubConnectionBuilder()
            .withUrl(this.actionUrl + queryStr, { transport: SignalR.HttpTransportType.LongPolling, accessTokenFactory: () => token })
            .configureLogging(SignalR.LogLevel.None).build();

        this._hubConnection.on('Send', (traffic: TrafficModel) => {
            this.newTrafficEvent.next(traffic);
        });

        this._hubConnection.on('RecieveMessage', (traffic: TrafficModel) => {
            this.newTrafficEvent.next(traffic);
        });

        this._hubConnection.onclose((e) => {
            this._notificationService.logToastWarning('Disconnected ' + identifier);
            this.isConnected.next(false);
        })

        this._hubConnection.start().then(() => {
            this._notificationService.logToastSuccess('Connected ' + identifier);
            this.isConnected.next(true);
        }).catch(err => {
            this._notificationService.handleError(err);
        });
    }

    public Disconnect(): void {
        try {
            if (this._hubConnection != null) {
                this._hubConnection.stop().then(() => {
                    //this._notificationService.logToastWarning('Disconnected.');
                    this.isConnected.next(false);
                });
                this._hubConnection = null;
            }
        } catch (e) {
            this._notificationService.handleError('Error while disconnecting.');
            this.isConnected.next(false);
        }
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/traffic/traffic-live/traffic-live.service.ts